import styled from "styled-components";
import media from "styled-media-query";

export const Background = styled.div`
  position: fixed;
  top: 0;
  left: 0;

  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  z-index: 1000;
`;

export const Modal = styled.div`
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
  width: 26%;
  height: fit-content;
  padding: 30px;

  position: fixed;
  bottom: 15px;
  right: 15px;

  background-color: white;

  display: flex;
  flex-direction: column;
  gap: 20px;

  border-radius: 10px;

  z-index: 99;

  h1 {
    font-size: 22px;
    color: ${({ theme }) => theme.colors.primary.blue};
    font-weight: 700;
  }

  ${media.lessThan("medium")`
    width: 90%;
    bottom: 85px;
  `}
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;

  svg {
    cursor: pointer;
  }
`;
export const Buttons = styled.div`
  width: 100%;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
`;
